<div [class.toast-mode]="toastMode">
	<ng-template ngFor let-alert let-index="index" [ngForOf]="values">
		<div
			[ngClass]="['alert-' + alert.severity, 'alert-dism']"
			class="alert alert-dismissible fade show shadow-alert"
			role="alert"
			@alertsAnimation
			(mouseenter)="stopToastTimer()"
			(mouseleave)="startToastTimer()"
		>
			<ng-container
				*ngTemplateOutlet="
					alertBodyTemplate;
					context: {
						$implicit: alert
					}
				"
			></ng-container>
			<ng-container *ngIf="!alertBodyTemplate">
				<i
					class="bi icon-alert"
					[ngClass]="{
						'bi-exclamation-triangle':
							alert.severity === 'warning' ||
							alert.severity === 'danger',
						'bi-info-circle': alert.severity === 'info',
						'bi-check2': alert.severity === 'success'
					}"
				></i>
				<strong>{{ alert.title }}</strong>
				<span [innerHTML]="alert.message"></span>
			</ng-container>

			<button
				*ngIf="dismissible"
				(click)="closeAlert(index)"
				type="button"
				class="btn-close"
				data-bs-dismiss="alert"
				aria-label="Close"
			></button>
		</div>
	</ng-template>
</div>
